import React from 'react'

const Caixa = (props) => {
    const estilo = {
        principal: {
            border: "1px solid #00000029", 
            margin: "auto", marginTop: "4vh", marginLeft: "4vw", marginRight: "4vw",
            paddingLeft: "4vw", paddingRight: "4vw", paddingBottom: "4vh"
        }
    }

    return (
        <div style={estilo.principal}>
            {props.children}
        </div>
    )
}

export default Caixa